import { Controller } from "@hotwired/stimulus"
import { apiGet } from "../shared/api"
import { escapeHtml, loadTranslations, t } from "../shared/utils"

export default class extends Controller {
  static targets = ["results", "pagination"]
  static values = { apiUrl: String }

  connect() {
    loadTranslations()
    this.page = 1
    this._fetchClubs(1)
  }

  async _fetchClubs(page) {
    const params = new URLSearchParams({ page })
    const data = await apiGet(`${this.apiUrlValue}?${params}`)
    if (!data) return

    this.page = data.meta.current_page
    this._renderClubs(data.data)
    this._renderPagination(data.meta)
  }

  _renderClubs(clubs) {
    if (!clubs.length) {
      this.resultsTarget.innerHTML = `
        <div class="text-center py-5">
          <i class="fa-solid fa-building fa-3x text-muted mb-3"></i>
          <h4>${t("index.no_clubs")}</h4>
          <p class="text-muted">${t("index.no_clubs_hint")}</p>
          <a href="/clubs/search" class="btn btn-outline-primary mt-3">${escapeHtml(t("index.search_clubs", { default: "Szukaj klubów" }))}</a>
        </div>`
      return
    }

    this.resultsTarget.innerHTML = `
      <p class="text-muted mb-4">${escapeHtml(t("index.subtitle"))}</p>
      <div class="row g-4">${clubs.map(c => this._clubCard(c)).join("")}</div>`
  }

  _clubCard(c) {
    const name = escapeHtml(c.name)
    const cityHtml = c.city
      ? `<p class="card-text text-muted small mb-0"><i class="fa-solid fa-location-dot me-1"></i>${escapeHtml(c.city)}</p>`
      : ""
    const trialBadge = c.on_trial
      ? `<span class="badge bg-info mt-2">${escapeHtml(t("index.on_trial"))}</span>`
      : ""

    return `
      <div class="col-lg-3 col-md-4 col-sm-6 col-12">
        <a href="/clubs/${escapeHtml(c.slug)}" class="card shadow-sm h-100 text-decoration-none text-dark d-block">
          <div class="card-body">
            <h5 class="card-title">${name}</h5>
            ${cityHtml}${trialBadge}
          </div>
        </a>
      </div>`
  }

  _renderPagination(meta) {
    if (meta.total_pages <= 1) {
      this.paginationTarget.innerHTML = ""
      return
    }

    const pages = []
    for (let i = 1; i <= meta.total_pages; i++) {
      const active = i === meta.current_page ? "active" : ""
      pages.push(`<li class="page-item ${active}"><a class="page-link" href="#" data-action="click->clubs-index#goToPage" data-page="${i}">${i}</a></li>`)
    }

    this.paginationTarget.innerHTML = `
      <div class="d-flex justify-content-center mt-4">
        <nav><ul class="pagination">${pages.join("")}</ul></nav>
      </div>`
  }

  goToPage(e) {
    e.preventDefault()
    const page = parseInt(e.currentTarget.dataset.page, 10)
    if (page && page !== this.page) {
      window.scrollTo({ top: 0, behavior: "smooth" })
      this._fetchClubs(page)
    }
  }
}
